import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip, FloatingTooltipContentText } from '../../Floating'
import Text from '../../Text'
import { isPersistentValue } from '../ListItem.utils'

import * as styles from './ListItemContent.module.css'

function ListItemContent({
  blocked,
  children,
  description,
  disabled,
  isActive,
  isFocused,
  isHovered,
  isPersistent,
  listExtraText,
  shouldAlwaysShowTooltip,
  text,
  textClassName,
  textContainerClassName = styles.textContainer,
  textQaName,
  tooltipAdditionalText,
  tooltipContent,
  tooltipPlacement,
  value,
}) {
  const { t } = useTranslation()

  const {
    overflow: overflowText,
    setContentOverflowRef: setTextContentOverflowRef,
  } = useContentOverflow()
  const {
    overflow: overflowDescription,
    setContentOverflowRef: setDescriptionContentOverflowRef,
  } = useContentOverflow()

  function getPreparedText() {
    if (text) {
      return isPersistentValue(value, isPersistent) ? t(text) : text
    }

    return text
  }

  const preparedText = getPreparedText()

  function getTooltipProps() {
    const tooltip = disabled && tooltipContent ? tooltipContent : preparedText

    if (disabled && tooltipContent) {
      return {
        content: tooltip,
        placement: tooltipPlacement,
      }
    }

    return {
      content: (
        <FloatingTooltipContentText
          additionalText={(!blocked && tooltipAdditionalText) || description}
          text={tooltip}
        />
      ),
      disabled:
        !shouldAlwaysShowTooltip && !overflowText && !overflowDescription,
      placement: tooltipPlacement,
    }
  }

  const tooltipProps = getTooltipProps()

  const mods = {
    [styles.disabled]: disabled,
    [styles.hover]: !blocked && (isActive || isFocused || isHovered),
  }

  const moddedTextClassName = classNames(styles.text, mods, textClassName)
  const descriptionClassName = classNames(styles.description, mods)

  return (
    <>
      {children}
      {preparedText ? (
        <FloatingTooltip {...tooltipProps}>
          <div className={textContainerClassName}>
            <Text
              className={moddedTextClassName}
              qaName={textQaName}
              ref={setTextContentOverflowRef}
            >
              {listExtraText}
              {preparedText}
            </Text>
            {description ? (
              <Text
                isSecondary
                className={descriptionClassName}
                ref={setDescriptionContentOverflowRef}
              >
                {description}
              </Text>
            ) : null}
          </div>
        </FloatingTooltip>
      ) : null}
    </>
  )
}

export default ListItemContent
